import React from "react";
import '../responsive.css'
import '../style.css';
import Donors from "./Donors";
const Footer = () => {
    const styles: Record<string, React.CSSProperties> = {
        sectionTitleAlt: {
            color: "#FFF",
            fontSize: "32px",
            //paddingBottom: "20px",
            margin: "5px",
            fontWeight: "normal",
        },
        footerContainer: {
            position: "relative",
            background: "#111111",
            borderTop: "solid 24px #131c81",
        },
        footerContent: {
            margin: "auto",
            padding: "60px 0px",
            textAlign: "center",
        },
        email: {
            color: "#1d77d7",
            textDecoration: "none",
            fontSize: "clamp(1rem, 5vw, 3rem)"
        },
    };

    return (
        <div className="footer">
            <div id="footerContainer" style={styles.footerContainer}>
                <div id="footerContent" style={styles.footerContent}>
                    <Donors />
                    <div id="connect">
                        <h3 className="sectionTitleAlt" style={styles.sectionTitleAlt}>
                            Connect With Us!
                        </h3>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center",}}>
                        <a
                            href="https://www.instagram.com/mizzousurf/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="/images/logos/Instagram_icon.png"
                                alt="Visit our Instagram"
                                className="social-icon"
                            />
                        </a>
                        <img className="officerGroupPhoto" src="images/officers/OfficersGroup.jpg" alt="OfficerGroupPhoto" 
                            style = {{objectFit:"cover"}}/>
                        <a href="https://discord.gg/DXbhb32p4b"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="/images/logos/discord_logo.png"
                                alt="Join our Discord"
                                className="social-icon"
                        />
                        </a>
                    </div>
                    <div>
                        <h5 className="sectionTitleAlt" style={styles.sectionTitleAlt}>Or, contact us at our email: <a href="mailto:muengrsurf@missouri.edu" style={styles.email}>muengrsurf@missouri.edu</a>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
